import { createSlice } from '@reduxjs/toolkit'
// utils
import {
	doc, getFirestore, increment, serverTimestamp, setDoc,
} from 'firebase/firestore'
import { pick } from 'lodash'
import { CustomizedTokenState } from '../../@types/customizedToken'
//
import { ICustomNft } from '../../@types/customToken'

// ----------------------------------------------------------------------

const initialState: CustomizedTokenState = {
	isLoading: false,
	error: null,
	customizedToken: null,
}

const slice = createSlice({
	name: 'customizedToken',
	initialState,
	reducers: {
		// START LOADING
		startLoading(state) {
			state.isLoading = true
		},

		// HAS ERROR
		hasError(state, action) {
			state.isLoading = false
			state.error = action.payload
		},

		// GET CUSTOM TOKEN
		getCustomizedTokenSuccess(state, action) {
			state.isLoading = false
			state.customizedToken = action.payload
		},

	},
})

// Reducer
export default slice.reducer

// Actions
export const {
	getCustomizedTokenSuccess,
	startLoading,
	hasError,

} = slice.actions

// ----------------------------------------------------------------------

// export const updateToken = async (uid:string, id:string, custom:ICustomNft):Promise<void> => {
export const updateToken = async (id:string, custom:any):Promise<void> => {
	const db = getFirestore()
	const values = {
		// ...pick(custom, ['name', 'gender']),
		...custom,
		updatedOn: serverTimestamp(),
		_version: increment(1),
	}
	const docRef = doc(db, 'customizedTokens', `${id}`)
	await setDoc(docRef, { ...values }, { merge: true })
}
